import { Injectable } from '@angular/core';
import { BxDisclaimContent } from '@buildxact/ui-components/bx-disclaim';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class QuoteRequestsStores {
    public quoteRequestsNotices$: Observable<BxDisclaimContent[]>;
    // @ts-ignore TS2345
    private quoteRequestsNoticesSource = new BehaviorSubject<BxDisclaimContent[]>(null);
    public set quoteRequestsNotices(notices: BxDisclaimContent[]) {
        this.quoteRequestsNoticesSource.next(notices);
    }

    public get quoteRequestsNotices(): BxDisclaimContent[] {
        return this.quoteRequestsNoticesSource.getValue();
    }

    constructor() {
        this.quoteRequestsNotices$ = this.quoteRequestsNoticesSource.pipe(
            filter((notices) => !!notices),
            distinctUntilChanged()
        );
    }
}
